import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@core/errors/api-error';

export class BadRequestApiError extends ApiError {
  constructor(cause: HttpErrorResponse, body: unknown) {
    super('BadRequestApiError', cause, body);
  }
}
